import { useRelayInfo } from "../../hooks";
import { useSnackbar } from "notistack";
import RelayAPI from "../../../../../api/RelayAPI";
import { Button, TextInput, Typography } from "@monolith-forensics/monolith-ui";
import { useForm } from "@mantine/form";
import { SectionContainer } from "./SectionContainer";

export const TenantEmail: React.FC = () => {
  const { relayInfo, refetch } = useRelayInfo();
  const { enqueueSnackbar } = useSnackbar();

  const form = useForm({
    initialValues: {
      tenant_email: relayInfo?.tenant_email,
    },
    validate: (values) => {
      const errors: any = {};

      if (!values.tenant_email) {
        errors.tenant_email = "This field is required";
        return errors;
      }

      if (!values.tenant_email.includes("@")) {
        errors.tenant_email = "Invalid email format";
      }

      return errors;
    },
  });

  if (!relayInfo) return null;

  const handleUpdate = async () => {
    const validationResults = form.validate();

    if (validationResults.hasErrors) {
      return;
    }

    const { tenant_email } = form.getValues();

    await RelayAPI.updateTenantEmail({
      tenant_email,
      tenant_uuid: relayInfo.tenant_uuid,
    });

    enqueueSnackbar("Relay tenant email updated successfully", {
      variant: "success",
    });

    refetch();
    form.clearErrors();
    form.resetDirty();
  };

  return (
    <SectionContainer>
      <div>
        <Typography variant="h3" display="inline">
          Tenant Email
        </Typography>
        <div className="message">
          This is the default email for your Relay tenant. Notifications from
          Relay (new users, requests, etc...) will be sent to this email
          address.
        </div>
      </div>
      <TextInput
        label="Tenant Email"
        placeholder="Enter a new Tenant email"
        style={{ maxWidth: 400 }}
        key={form.key("tenant_email")}
        {...form.getInputProps("tenant_email")}
      />
      <div>
        <Button
          variant="contained"
          color="primary"
          style={{ marginLeft: "auto" }}
          size="xs"
          disabled={!form.isDirty()}
          onClick={handleUpdate}
        >
          Update Email
        </Button>
      </div>
    </SectionContainer>
  );
};
